import {pick} from 'lodash';

import QuestionListPage from '../../js/pages/QuestionListPage';
import {QUERY_PARAMS} from '../../js/constants/questions';

import {tagSocratesVisitor} from '../../../server/services/email/tags';
import {getQuestions} from '../../../server/services/questions';
import {getTags, getQuestionTagsFromQuery} from '../../../server/services/tags';

export default QuestionListPage;

export async function getServerSideProps({req, query}) {
  const params = pick(query, QUERY_PARAMS);

  const [questionsResult, {allTags: tagMap}, tags] = await Promise.all([
    getQuestions({query: params, user: req.user}),
    getTags(),
    getQuestionTagsFromQuery({
      ...(params.role ? {role: params.role} : {}),
      ...(params.type ? {category: params.type} : {}),
      ...(params.company ? {company: params.company} : {}),
    }),
  ]);

  if (req.user) await tagSocratesVisitor(req.user);

  const serializedResults = JSON.parse(JSON.stringify(questionsResult));

  return {
    props: {
      initialQuestions: {
        results: serializedResults.results,
        pagination: serializedResults.pagination,
        count: serializedResults.pagination.count,
      },
      tagMap,
      initialTags: tags,
    },
  };
}
